import Header from "./components/Header"
import Songs from "./components/Songs";

const Home = () => {
    return (
        <div>
            <Header />
            <Songs />
        </div>
    );
};

export default Home;